module.exports = __webpack_public_path__ + "static/img/s-hw-1.ffd16a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-hw-1.png
// module id = LXfw
// module chunks = 1